var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPendingCaseStatusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.79974 0.766602C10.2421 0.766602 13.0331 3.5576 13.0331 6.99993C13.0331 10.4423 10.2421 13.2333 6.79974 13.2333C3.35741 13.2333 0.566406 10.4423 0.566406 6.99993C0.566406 3.5576 3.35741 0.766602 6.79974 0.766602ZM6.06724 4.58634C6.06724 3.62963 7.52514 3.62862 7.52514 4.58837V7.20081L9.17173 8.0723C9.17985 8.07636 9.18797 8.08143 9.19507 8.08752L9.20927 8.09767C9.97423 8.59885 9.26304 9.80311 8.44532 9.33033L8.44228 9.3283L6.44972 8.26101C6.21638 8.13622 6.06521 7.88867 6.06521 7.62286H6.06623L6.06724 4.58634Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingCaseStatusIcon);
export default __webpack_public_path__ + "static/media/pendingCaseStatusIcon.b40993ab77b46784cb28784e6f90abaa.svg";
export { ForwardRef as ReactComponent };